// Global Types
import type {
  $Model,
} from 'common.data';

// Helpers
import _ from 'lodash';

// Enums
import * as authActionTypes from './types';

// Types
import type {
  $ActionEnvelope,
  $ReducerActions,
} from '../..';

export type $State = {
  error: null | string;
  loading: boolean;
  user: $Model<'Crewmember'> | null;
};

export const initialState: $State = {
  error: null,
  loading: false,
  user: null,
};

const actionStart = (state: $State): $State => ({
  ...state,
  error: null,
  loading: true,
});

const actionEndSetUser = (state: $State, payload?: $Model<'Crewmember'>): $State => ({
  ...state,
  loading: false,
  user: payload || null,
});

const actionError = (state: $State, payload: Error): $State => ({
  ...state,
  error: payload.message,
  loading: false,
});

const reducerActions: $ReducerActions<'auth'> = {
  [`${authActionTypes.AUTHENTICATE}_FULFILLED`]: actionEndSetUser,
  [`${authActionTypes.AUTHENTICATE}_PENDING`]: actionStart,
  [`${authActionTypes.AUTHENTICATE}_REJECTED`]: actionError,
  [`${authActionTypes.SET_AUTH_USER}_FULFILLED`]: actionEndSetUser,
  [`${authActionTypes.SET_AUTH_USER}_PENDING`]: actionStart,
  [`${authActionTypes.SET_AUTH_USER}_REJECTED`]: actionError,
  [`${authActionTypes.SETUP_AUTHENTICATION}_FULFILLED`]: actionEndSetUser,
  [`${authActionTypes.SETUP_AUTHENTICATION}_PENDING`]: actionStart,
  [`${authActionTypes.SETUP_AUTHENTICATION}_REJECTED`]: actionError,
  [`${authActionTypes.UNAUTHENTICATE}_FULFILLED`]: actionEndSetUser,
  [`${authActionTypes.UNAUTHENTICATE}_PENDING`]: actionStart,
  [`${authActionTypes.UNAUTHENTICATE}_REJECTED`]: actionError,
};

export type $Reducer = (arg0: $State, arg1: $ActionEnvelope<$ReducerActions<'auth'>>) => $State;

const reducer: $Reducer = (prevState, action) => {
  const state = prevState || initialState;

  const reducerAction = _.get(
    reducerActions,
    action.type,
    () => state,
  );

  return reducerAction(
    state,
    action.payload,
  );
};

export default reducer;
